import {
  ROUTE_QUIZ_BUDGET,
  ROUTE_QUIZ_BUDGET_BENEFITS,
  ROUTE_QUIZ_DINNER,
  ROUTE_QUIZ_EATING_HABITS,
  ROUTE_QUIZ_EATING_HABITS_DIETARY_NEEDS,
  ROUTE_QUIZ_GOALS,
  ROUTE_QUIZ_GOALS_BENEFITS,
  ROUTE_QUIZ_HELLO,
  ROUTE_QUIZ_INTRO,
  ROUTE_QUIZ_LUNCH,
  ROUTE_QUIZ_MACRO_NUTRIENT,
  ROUTE_QUIZ_MACRO_NUTRIENT_LOW_SODIUM,
  ROUTE_QUIZ_BREAKFAST,
  ROUTE_QUIZ_CUISINES,
  ROUTE_QUIZ_FLAVORS,
  ROUTE_QUIZ_POLARIZING,
  ROUTE_QUIZ_PROTEIN,
  ROUTE_QUIZ_SNACKS,
  ROUTE_QUIZ_SWEETS,
} from '@hungryroot/routes';

// Includes all stable (non-experimental) quiz routes
export const navigationOrder = [
  ROUTE_QUIZ_INTRO,
  ROUTE_QUIZ_HELLO,
  ROUTE_QUIZ_GOALS,
  ROUTE_QUIZ_GOALS_BENEFITS,
  ROUTE_QUIZ_BUDGET,
  ROUTE_QUIZ_BUDGET_BENEFITS,
  ROUTE_QUIZ_EATING_HABITS,
  ROUTE_QUIZ_EATING_HABITS_DIETARY_NEEDS,
  ROUTE_QUIZ_MACRO_NUTRIENT,
  ROUTE_QUIZ_MACRO_NUTRIENT_LOW_SODIUM,
  ROUTE_QUIZ_CUISINES,
  ROUTE_QUIZ_FLAVORS,
  ROUTE_QUIZ_PROTEIN,
  ROUTE_QUIZ_POLARIZING,
  ROUTE_QUIZ_BREAKFAST,
  ROUTE_QUIZ_LUNCH,
  ROUTE_QUIZ_DINNER,
  ROUTE_QUIZ_SNACKS,
  ROUTE_QUIZ_SWEETS,
];
